import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CircularRequestComponent } from 'src/app/front-user/services/Circulars/circular-request/circular-request.component';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { CircularsFixedRebateOptions, Percentages } from 'src/app/shared/models/circular.model';
import { ErrorsEnum, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CircularService } from 'src/app/shared/services/circular.service';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-circulars-cancel-request',
  templateUrl: './circulars-cancel-request.component.html',
  styleUrls: ['./circulars-cancel-request.component.css']
})
export class CircularsCancelRequestComponent implements OnInit {
  //#region Properties & Variables
  @ViewChild('circularsRequest',{static: false}) circularsRequest: CircularRequestComponent;
  @Output() cancelRequestLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  public isRequestSucceeded: boolean = false;
  private ResponseObject: ResponseObject = new ResponseObject();
  private formMode: FormMode = FormMode.New;
  public isFormValid: boolean = true;
  public isShow: boolean = true;
  public cancelationReasonNotValid: boolean = false;
  public currentUser: User = new User();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion
  constructor(private circularsService: CircularService, public datepipe: DatePipe, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
  }
  onCircularsRequestLoadedFlag(flag: boolean) {
    if (flag) {
      if (this.circularsRequest.rebateRequestLoaded.InternalStatusId == ServiceStatus.Circulars_AcceptedByRequestor
        || this.circularsRequest.rebateRequestLoaded.InternalStatusId == ServiceStatus.Circulars_ShipPassed
        || this.circularsRequest.rebateRequestLoaded.InternalStatusId == ServiceStatus.Circulars_CanceledByRequestor
        || this.circularsRequest.rebateRequestLoaded.ExternalStatusId == ServiceStatus.Circulars_AcceptedByRequestor
        || this.circularsRequest.rebateRequestLoaded.ExternalStatusId == ServiceStatus.Circulars_ShipPassed
        || this.circularsRequest.rebateRequestLoaded.ExternalStatusId == ServiceStatus.Circulars_CanceledByRequestor) {
        this.circularsRequest.insideCancelationComponents = true;
        this.setFormMode();
      }
      this.cancelRequestLoadedFlag.emit(true);
      this.circularsRequest.editModeAdmin = true;
    }
  }

  OnCancelRequestChange() {
    if (this.circularsRequest.rebateRequestLoaded.IsCanceled == false) {
      this.circularsRequest.rebateRequestLoaded.CancelationReason = ""
    }
  }
  submit(): void {
    //Check Form Validity
    if (this.circularsRequest.rebateRequestLoaded.IsCanceled) {
      if (this.circularsRequest.rebateRequestLoaded.CancelationReason == "" || this.circularsRequest.rebateRequestLoaded.CancelationReason == null) {
        this.isFormValid = false;
        this.cancelationReasonNotValid = true;
      } else {
        this.isFormValid = true;
        this.cancelationReasonNotValid = false;
      }
    } else {
      this.isFormValid = false;
    }
    if (this.isFormValid) {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.submitCancel();
    }
  }
  submitCancel(): void {
    this.circularsService.cancelRequest(this.circularsRequest.rebateRequestLoaded).subscribe(
      data => this.ResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitCancelCompleted()
    );
  }
  submitCancelCompleted(): void {
    if (!this.ResponseObject.Success) {
      //Enable Error / Warning
      if (this.ResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if (this.ResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
    this.isRequestSucceeded = true;
  }

  setFormMode(): void {
    if (this.circularsRequest.rebateRequestLoaded.IsCanceled) {
      this.formMode = FormMode.Details;
    }
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({ behavior: 'smooth' });
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
    console.log(this.formMode);
  }

}

enum FormMode {
  New = 1,
  Details = 2
}

enum ConfirmationMode {
  Success = 1,
  Warning = 2,
  Error = 3
}

